// ===========================================================================
// Design tokens — Coding Opportunity Workspace (V2)
//
// Traducidos desde el sistema de diseño médico de la referencia visual
// (docs/modulos/coding-opportunities/V2/EJEMPLO_UI_CODING_OPPORTUNITY.html).
// Paleta teal, tipografía mono para números, densidad compacta.
//
// Se exponen como objeto JS para usarlos con el prop `sx` de MUI (el proyecto
// usa MUI, no Tailwind como sugería el doc original).
// ===========================================================================

export const T = {
  canvas: "#EEF1F3",
  surface: "#FFFFFF",
  surface2: "#F6F8F9",
  line: "#D8DEE2",
  lineStrong: "#B6C0C6",

  ink: "#16242B",
  ink2: "#4A5C66",
  ink3: "#7C8B93",

  primary: "#0F6E6E",
  primary700: "#0A5252",
  primary50: "#E2F0EF",

  ok: "#1F8A5B",
  okBg: "#E4F3EC",
  warn: "#B5760A",
  warnBg: "#FBF0DC",
  crit: "#C0392B",
  critBg: "#FBE7E4",
  info: "#1B5FA8",
  infoBg: "#E4EEF8",
  muted: "#7C8B93",
  mutedBg: "#EDF0F2",
};

// Familia mono para valores tabulares (RAF$, CIP, códigos, contadores).
// IBM Plex Mono se carga vía Google Fonts en index.html; con fallback robusto.
export const MONO =
  "'IBM Plex Mono', 'Roboto Mono', ui-monospace, SFMono-Regular, Menlo, monospace";

// Semántica de color por tono de pill/banner.
export const TONE = {
  ok: { fg: T.ok, bg: T.okBg },
  warn: { fg: T.warn, bg: T.warnBg },
  crit: { fg: T.crit, bg: T.critBg },
  info: { fg: T.info, bg: T.infoBg },
  muted: { fg: T.muted, bg: T.mutedBg },
};
